























































import { Vue, Component } from "vue-property-decorator";
//导入element-ui中form的类型接口
import { Form as ElForm } from "element-ui";
//获取统一身份认证登录参数
import { getLoginParam } from "../../../utils/auth";
//引入vuex中的user模块
import { UserModule } from "../../../store/modules/user";
import { getSchoolCode } from "@/api/login"
// 引入sm3哈希算法
import sm3 from 'sm3'

@Component({
  name: "school"
})
export default class Login extends Vue {
  private role: string = "school"; //登录的角色
  private schoolLoginForm = {
    username: "",
    password: "",
    phoneCode: "",
    key: ""
  };
  private loginRules = {
    username: [{required: true, message: "请输入账号", trigger: "blur"}],
    password: [{required: true, message: "请输入密码", trigger: "blur"}],
    phoneCode: [{required: true, message: "请输入验证码", trigger: "blur"}]
  };
  private loginLoading: boolean = false;
  private imgUrl = '';
  private manualName: string = '管理员操作说明.doc';
  private publicPath: string = process.env.BASE_URL;
  private get manualUrl(): string {
    return `${this.publicPath}manual/${this.manualName}`;
  }

  created() {
    //进入页面，判断路径中是否有 code，如果有，说明统一身份处于登录状态
    //TODO:正式流程，下面这一行要打开
    this.handleCode()
    this.commonLoginHandle();
  }

  //点击统一身份认证跳转，如果未登录，则会跳转到统一登录界面；如果已登录，则会携带code，跳回参数中指定的redirectUrl
  private goCommonLogin() {
    let link =
      window.config.loginBaseUrl + "/oauth/authorize?" + getLoginParam();
    window.location.href = link;
  }

  //帐户名不为空，按enter直接光标定位在密码
  private setPasswordFocus() {
    let passwordDom: any = this.$refs['password'];
    if (this.schoolLoginForm['username'] !== "") passwordDom.focus();
  }

  private setCaptchaFocus() {
    let captchaDom: any = this.$refs['captcha'];
    if (this.schoolLoginForm['password'] !== "") captchaDom.focus();
  }

  // 获取验证码
  private async handleCode() {
    try {
      let res = await getSchoolCode()
      this.imgUrl = res.data.image
      UserModule.setVerifyCode(res.data.verificationCode)
    } catch (error) {
      this.$message('图片获取失败')
    }
  }

  //统一身份认证-登录处理
  private commonLoginHandle() {
    // 获取code
    let code = this.$route.query.code;
    let param = getLoginParam();
    //如果有code，则表示统一身份处于登录状态，下一步是获取Access Token
    if (code) {
      this.setAuthToken(param + "&code=" + code);
    }
  }

  //统一身份认证-获取access token
  private async setAuthToken(postData: any) {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      //调取UserModule中，获取统一身份认证的 Access Token （token的存储逻辑在 UserModule 中完成）
      await UserModule.GetAccessToken(postData);
      // 跳转到菜单面板
      this.$router.push({
        path: '/layout'
      })
      loading.close();
    } catch (error) {
      this.$message(error || "登录失败");
      loading.close();
    }
  }

  //专家系统自身的 学校登录 处理
  private loginHandle() {
    //需要声明form的类型，否则找不到validate
    (this.$refs.schoolLoginForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loginLoading = true;
        // 密码加密：仅SM3哈希，不再Base64
        const password = this.schoolLoginForm.password
        const convertPwd = sm3(password)
        let params = Object.assign({}, this.schoolLoginForm);
        params.password = convertPwd
        params['key'] = UserModule.verificationCode
        try {
          //调登录的接口，获取token（token的存储逻辑在 UserModule 中完成）
          const data = await UserModule.SchoolLogin(params);

          if (data) {
            this.$router.push({path: "/layout"});
          }
          this.loginLoading = false;
        } catch (error) {
          this.loginLoading = false;
          this.schoolLoginForm.phoneCode = '';
          this.handleCode()
        }
      }
    });
  }

  private getToTeacher() {
    this.$router.push({path: "/teacher"});
  }
}
